module.exports = __webpack_public_path__ + "img/layout-content.2ac040aa.svg";